var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 134,
    viewBox: "0 0 136 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1040_2463)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.237,
    cy: 66.5308,
    rx: 60.4753,
    ry: 60.4751,
    fill: "#F1D33D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5155,
    cy: 64.8026,
    rx: 41.4687,
    ry: 41.4686,
    fill: "#EFC636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.712 66.5308C126.712 82.224 120.612 97.3027 109.7 108.581C98.7876 119.86 83.9186 126.455 68.2338 126.973C52.5491 127.491 37.2772 121.892 25.6445 111.358C14.0118 100.824 6.92938 86.1813 5.89359 70.5223L10.8081 70.1972C11.7595 84.5809 18.2651 98.0315 28.9504 107.707C39.6357 117.383 53.6639 122.526 68.0712 122.05C82.4785 121.574 96.1366 115.516 106.16 105.157C116.183 94.7965 121.787 80.9459 121.787 66.5308L126.712 66.5308Z",
    fill: "#E7A324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.061 64.8054C109.061 76.0148 104.704 86.7853 96.9092 94.8414C89.1149 102.897 78.4942 107.608 67.2908 107.978C56.0875 108.348 45.179 104.349 36.8699 96.8249C28.5608 89.3009 23.502 78.8415 22.7622 67.6565L26.2725 67.4243C26.9521 77.6983 31.599 87.3059 39.2313 94.2172C46.8636 101.128 56.8837 104.802 67.1747 104.462C77.4656 104.122 87.2213 99.7952 94.3809 92.3952C101.54 84.9952 105.543 75.1019 105.543 64.8054H109.061Z",
    fill: "#E1C84D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.95 69.7174C22.486 63.8341 23.231 57.9179 25.139 52.3338C27.047 46.7497 30.0775 41.6163 34.0434 37.2501C38.0094 32.884 42.8268 29.3779 48.1983 26.948C53.5698 24.5182 59.3814 23.2162 65.2747 23.1224C71.168 23.0286 77.0178 24.1449 82.4633 26.4026C87.9088 28.6603 92.8344 32.0113 96.9362 36.2491C101.038 40.4868 104.229 45.5212 106.312 51.0418C108.395 56.5623 109.327 62.4518 109.049 68.347L105.539 68.1813C105.795 62.7663 104.939 57.3565 103.025 52.2855C101.112 47.2146 98.1808 42.5901 94.4131 38.6976C90.6454 34.805 86.1209 31.7268 81.1189 29.653C76.117 27.5792 70.7435 26.5538 65.3302 26.6399C59.9169 26.7261 54.5786 27.9221 49.6445 30.154C44.7105 32.386 40.2855 35.6066 36.6425 39.6171C32.9995 43.6276 30.2159 48.343 28.4633 53.4723C26.7107 58.6016 26.0264 64.036 26.4525 69.4402L22.95 69.7174Z",
    fill: "#E7A324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03735 70.8376C5.22524 62.6868 6.13736 54.4659 8.71653 46.6903C11.2957 38.9147 15.4863 31.7521 21.0256 25.6514C26.5649 19.5508 33.3335 14.6437 40.907 11.2378C48.4805 7.8319 56.6956 6.00064 65.0373 5.85884C73.379 5.71703 81.6674 7.26773 89.3828 10.4137C97.0982 13.5597 104.074 18.2331 109.874 24.141C115.673 30.0489 120.171 37.0638 123.085 44.7461C125.999 52.4283 127.267 60.6121 126.808 68.7845L121.882 68.4995C122.303 60.9927 121.139 53.4754 118.462 46.4188C115.786 39.3623 111.654 32.9186 106.327 27.4919C101 22.0652 94.592 17.7723 87.5049 14.8826C80.4178 11.9928 72.8045 10.5684 65.1422 10.6987C57.4799 10.8289 49.9338 12.511 42.9771 15.6395C36.0204 18.7681 29.8031 23.2755 24.7149 28.8793C19.6267 34.4831 15.7774 41.0624 13.4083 48.2047C11.0392 55.3471 10.2013 62.8984 10.9473 70.3853L6.03735 70.8376Z",
    fill: "#E1C84D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1040_2463",
    x: 4.75,
    y: 2.8501,
    width: 131.148,
    height: 131.156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1040_2463"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1040_2463",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.735c7d934254d37ea2f20644bdbb28b9.svg";
export { ForwardRef as ReactComponent };